import {
  ICONS,
  PLATFORM_THEME_COLORS,
  Button,
  ButtonsWrapper,
} from '@thinknet-gmbh/platform-common-ui';
import { useTranslation } from 'react-i18next';

const BoxExpandButtons = ({
  isEdit,
  createElement,
  openEdit,
  createButtonTxt,
  canCreate,
  canEdit,
}: {
  isEdit: boolean;
  createElement: () => void;
  openEdit: () => void;
  createButtonTxt: string;
  canCreate?: boolean;
  canEdit?: boolean;
}) => {
  const { t } = useTranslation(['common', 'settings']);

  return (
    <ButtonsWrapper>
      {canCreate && (
        <Button
          type="primary"
          ghost
          icon={ICONS.plus}
          onClick={createElement}
          iconColor={PLATFORM_THEME_COLORS.primary.blue}
        >
          {createButtonTxt}
        </Button>
      )}

      {!isEdit && canEdit && (
        <Button
          type="primary"
          ghost
          icon={ICONS.editAlt}
          onClick={openEdit}
          iconColor={PLATFORM_THEME_COLORS.primary.blue}
        >
          {t('common:buttons.edit')}
        </Button>
      )}
    </ButtonsWrapper>
  );
};

export default BoxExpandButtons;
